import Guid from "../Guid";
/*import VideoCamera from "../VideoCamera";*/
import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";
import React, {useContext, useRef, useState} from "react";
import ProgressLoading from "../loading/ProgressLoading";
import VideoValidationGuideImage from "../../images/guide/VideoValidation_guide.png";
import Api from "../../tools/service";
import handleGenerateUuid from "../../tools/api/global/generateUuid";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";
import UserAuthenticationContext from "../../tools/contexts/authenticatonService/UserAuthenticationContext";
import UserReportedCard from "./UserReportedCard";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import VideoCamera1 from "../VideoCamera1";

const VideoValidation=()=>{
    const userAuthenticationContext=useContext(UserAuthenticationContext);
    const videoValidationWebcam=useRef(null);
    const [showGuide,setShowGuide]=useState(true);
    const [isLoading,setLoading]=useState(false)
    const [step,setStep]=useState(1);
    const [video,setVideo]=useState('')
    const [warning,setWarning]=useState(false)
    const [warningMessage,setWarningMessage]=useState('');
    const userSpeechText=userAuthenticationContext.process?.speech
    const [timerCount,setTimerCount]=useState(userSpeechText ? 12:7);
    const [status,setStatus]=useState(null)
    const VideoValidationGuidSlides=[
        {
            image:VideoValidationGuideImage,
            title:"ونیفای",
            subTitle:"احراز هویت ویدیویی",
            texts:`در شرایط نوری مناسب  بدون عینک و ماسک از چهره خود ویدیو بگیرید.`
        }
    ]
    if(isLoading){
        return <ProgressLoading showProgress={true} type="VideoValidation" text={'در حال احراز هویت ویدیو'} duration={30} theme="green" />
    }

    const handleVideoValidation=()=>{
        setLoading(true);
        const videoIndex = video.indexOf(";base64,") + 8;
        handleGenerateUuid('VideoValidation',userAuthenticationContext.token).then((generatedUuid)=>{
            Api.post(REQUEST_URLS.DIVAR_INTERNAL_AUTH.VIDEO_VALIDATION, {
                pid:userAuthenticationContext.pid,
                uuid:generatedUuid,
                Video:video.substr(videoIndex),
            },{
                headers:{
                    "Authorization": `Bearer ${userAuthenticationContext.token}`
                }
            }).then((response) => {

                const {data, hasError,status, message} = response;

                if (!hasError) {
                    if(data.warning){
                        setWarning(true)
                        setWarningMessage(data.warning);
                        setStatus('pending')

                        setLoading(false);
                    }else {

                        setWarning(true)
                        setWarningMessage('');
                        setLoading(false);

                        setStatus('success')

                    }


                } else {
                    setLoading(false);
                    if(status==521){
                        setTimerCount(13)
                    }
                    userAuthenticationContext.handleError({
                        message,status,data,callback:()=>{
                            Reoverlay.showModal(ErrorModal,{
                                title:'خطا',
                                message:message||'خطای سرویس' ,
                                pid:userAuthenticationContext.pid,
                                onConfirm:()=>{
                                        if(data?.can_reset){
                                            userAuthenticationContext.handleReset(userAuthenticationContext.pid);
                                            Reoverlay.hideModal();
                                        }
                                },
                                showConfirmButton:data?.can_reset,
                                showCancelButton:true,
                                cancelButtonText:'تلاش مجدد',
                                confirmButtonText:'ویرایش اطلاعات',
                                cancelButtonTheme:'red',
                                onCancel:()=>{
                                    setShowGuide(false)
                                    setStep(1);
                                    Reoverlay.hideModal();

                                }
                            })
                        }
                    })

                }}).catch((error) => {
                console.log(error)
                setLoading(false)
            }).finally(() => {

            });
        }).catch(()=>{

        })
    }
    const handlePrev=()=>{
        setStep(step-1)
    }
    const handleCapture=(video)=>{
        setVideo(video);
        setStep(step+1)

    }

    if(warning){
        return  <UserReportedCard status={status} title={status==="success" ? 'بررسی هویت با موفقیت انجام شد':'در حال بررسی'} message={warningMessage}/>
    }
    return <div className="w-11/12 mx-auto md:w-6/12 mt-5 lg:w-4/12">
        {showGuide&&   step===1&& <Guid    imageClass={'w-8/12 md:w-8/12 lg:w-3/12 xl:w-2/12 '}  closeGuid={()=>setShowGuide(false)} slides={VideoValidationGuidSlides}/>}
        {!showGuide&&  step===1&&   <VideoCamera1 title={'احراز هویت ویدیو'} min={timerCount} max={timerCount}  handleShowGuid={()=>{setShowGuide(true)}} webcamRef={videoValidationWebcam} text2={userSpeechText} text={userSpeechText ? ' متن زیر را با صدای بلند بخوانید':null}  faceMode="user" onCapture={handleCapture} isVideo={false} type="face"/>}
        {!showGuide&&  step===2&&   <>
            <div className="w-full flex justify-center  flex-col items-center ">
                <div className="w-full lg:w-56 overflow-hidden">
                    <video className={"cursor-pointer"}   controls onClick={e => e.target.play()}
                           src={video}/>
                </div>
            </div>
            <BottomButtonWrapper grid={2}>
                <Button onClick={handleVideoValidation} className={"w-full"} rounded="rounded-lg" theme="green" >تایید</Button>
                <Button onClick={()=>{handlePrev()}} className={"w-full"} rounded="rounded-lg" theme="light" >تلاش مجدد</Button>
            </BottomButtonWrapper>
        </>}

    </div>
}
export default VideoValidation;